/**
 * @generated SignedSource<<16f4cb4f4460474d58d14cdfa8c110f0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type VideoStatusEnum = "pending" | "processed" | "processing" | "processing_failed" | "processing_queued" | "processing_rejected" | "unprocessed";
import { FragmentRefs } from "relay-runtime";
export type AnswerListItemStatus_Video$data = {
  readonly id: string;
  readonly rejectReason: string | null | undefined;
  readonly status: VideoStatusEnum;
  readonly " $fragmentType": "AnswerListItemStatus_Video";
};
export type AnswerListItemStatus_Video$key = {
  readonly " $data"?: AnswerListItemStatus_Video$data;
  readonly " $fragmentSpreads": FragmentRefs<"AnswerListItemStatus_Video">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AnswerListItemStatus_Video",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "rejectReason",
      "storageKey": null
    }
  ],
  "type": "Video",
  "abstractKey": null
};

(node as any).hash = "5003f1e9127b8e98aa8ec81468529682";

export default node;
